import { type AccommodationDto } from '@hcr/api/consumer'

export const isOwnerUsage = ({ segment_name }: AccommodationDto): boolean => {
  return (
    segment_name === 'owner-usage' ||
    segment_name === 'owner-usage-points' ||
    segment_name === 'unconfirmed-owner-usage'
  )
}
